import { render, staticRenderFns } from "./Auth2.vue?vue&type=template&id=57ecbba9&scoped=true"
import script from "./Auth2.vue?vue&type=script&lang=js"
export * from "./Auth2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ecbba9",
  null
  
)

export default component.exports